import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { TunnelClient } from './client.js';

export function useTunnelClient(): TunnelClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  return useMemo(() => new TunnelClient(httpClient), [httpClient]);
}
